import * as ko from "knockout";
import * as $ from "jquery";
import * as validation from "knockout.validation";
import * as AutoNumeric from "autonumeric";
import "./Validation/Localization/hu-HU";

import { ComponentRegistration } from "../Knockout/componentRegistration";
import { CustomBindingHandlers } from "../Knockout/customBindingHandlers";

export class KnockoutInitialization {

    static initKo() {
        ComponentRegistration.registerComponents();
        CustomBindingHandlers.initCustomBinding();

        validation.init({
            decorateInputElement: false,
            insertMessages: false,
            errorElementClass: "is-invalid",
            errorMessageClass: "invalid-feedback"
        }, true);

        validation.locale("hu-HU");

        ko.applyBindings({}, document.body);
    }

}